module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "tx-ni ParaOverride-1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni ParaOverride-3",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_vm._v("For my great-nephew Harry James Estep, who entered this world at 6:31 p.m. on the evening of June 15, 2018. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni ParaOverride-2"
  }, [_vm._v("—"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Richard Estep")])]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni ParaOverride-3"
  }, [_vm._v("In memory of the victims. May they rest in peace. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni ParaOverride-2"
  }, [_vm._v("—"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Robert Graves")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787d1afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ded.vue
// module id = 69
// module chunks = 0